import React, { useState } from 'react';
import { Button } from 'antd';
import { BarChartOutlined, DownloadOutlined, FilePdfOutlined } from '@ant-design/icons';
import './index.scss';
import SVGIcons from '../../../../../../Components/SVGIcons';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const two = (n) => String(n).padStart(2, '0');
// "11 Aug, 13:01"
const formatUpdated = (d) => `${two(d.getDate())} ${MONTHS[d.getMonth()]}, ${two(d.getHours())}:${two(d.getMinutes())}`;

// Page header for Benchmark Analysis: eyebrow pill, title, subtitle, and the
// Download-PDF action + "last updated" chip. `onDownload` drives the existing
// PDF export flow (BenchmarkAnalysis's handlePreview); `downloading` mirrors
// that flow's loading state on this button. `apiLoading` (from this file's
// connected index.js) disables the button while any benchmark API is still
// fetching, since the preview would otherwise snapshot incomplete data.
const AnalysisHeader = ({ onDownload, downloading, apiLoading }) => {
    // No backend "last updated" timestamp exists for this dataset yet, so this
    // captures "now" once at mount as a reasonable stand-in for "data as of".
    const [updatedAt] = useState(() => formatUpdated(new Date()));

    return (
        <div className='analysis-header'>
            <div className='analysis-header__left'>
                <span className='analysis-header__pill'>
                    <BarChartOutlined /> Benchmark Analysis
                </span>
                <div className='analysis-header__title'>Explore what your feedback is saying</div>
                <div className='analysis-header__subtitle'>
                    Slice the benchmark by date, survey and rater group, then compare behaviors across the organization.
                </div>
            </div>

            <div className='analysis-header__actions'>
                <Button
                    className='analysis-header__download'
                    icon={<FilePdfOutlined />}
                    loading={downloading}
                    disabled={downloading || apiLoading}
                    onClick={onDownload}
                >
                    {downloading ? 'Preparing…' : 'Preview PDF'}
                </Button>
                <span className='analysis-header__updated'>
                    <SVGIcons type={"SVG-giststar"} />
                    Updated {updatedAt}
                </span>
            </div>
        </div>
    );
};

export default AnalysisHeader;
